import React from "react";

const Search = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20.845" height="20.847" viewBox="0 0 20.845 20.847">
        <path d="M20.369,18.064,15.5,13.191a8.468,8.468,0,1,0-2.3,2.306l4.873,4.873a1.63,1.63,0,0,0,2.3-2.306ZM3.221,8.468A5.211,5.211,0,1,1,8.433,13.68,5.217,5.217,0,0,1,3.221,8.468Z" transform="translate(-0.001 0)" fill="currentColor"/>
    </svg>

}

export default Search;
